import {createSlice} from '@reduxjs/toolkit';
import axios from 'axios';
import API_URL from '../apiUrl';

const initialstate = {
    students_list: [],
    current_student_data: null,
    class: null,
    section: null,
    classes: null,
    sections: null,
    theoritical_subjects: null,
    grading_subjects: null
}

export const studentSlice = createSlice({
    name: 'student',
    initialState: initialstate,
    reducers: {
        setStudentsList: (state, action) => {
            state.students_list = action.payload
        }, 
        setCurrentStudentData: (state, action) => {
            state.current_student_data = action.payload
        },
        setClass: (state, action) => {
            state.class = action.payload
        },
        setSection: (state, action) => {
            state.section = action.payload
        }, 
        setTheoreticalSubjects: (state, action) => {
            state.theoritical_subjects = action.payload
        },
        setGradingSubjects: (state, action) => {
            state.grading_subjects = action.payload
        },
        setClasses: (state, action) => {
            state.classes = action.payload
        },
        setSections: (state, action) => {
            state.sections = action.payload
        }
    }
})

export const {setStudentsList, setCurrentStudentData, setClass, setSection, setTheoreticalSubjects, setGradingSubjects, setClasses, setSections} = studentSlice.actions;

export const getStudentsList = () => async(dispatch, getState) => {
    try {
        if(!getState().student.class || !getState().student.section) return;
      const response = await axios.get(`${API_URL}students/studentsByClassSection?class=${getState().student.class}&section=${getState().student.section.toLocaleLowerCase()}`);

      const data = await response.data;
        dispatch(setStudentsList(data));
    } catch (error) {
        dispatch(setStudentsList([]));
        console.error(error);
    }
};

export const getStudentById = (id) => async(dispatch, getState) => {
    try{
        const response = await axios.get(`${API_URL}students/studentById/${id}`);
        const data = await response.data;
        dispatch(setCurrentStudentData(data));
    }
    catch(error){
        dispatch(setCurrentStudentData(null));
        console.error(error);
    }
}
export const updateStudents = (data, id) => async(dispatch, getState) => {
    try{
        console.log( id)
        if(!id){
            await axios.post(
               `${API_URL}students/addStudentData`,
                data,
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              );
              return;
        }

        console.log("Updating Form")
        await axios.patch(
           `${API_URL}students/studentById/${id}`,
            data,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );
    }
    catch(error){
        console.error(error);
    }
}

export const deleteStudentById = (id) => async(dispatch, getState) => {
    try{
        const response = await axios.delete(`${API_URL}students/studentById/${id}`);
        const data = await response.data;
        dispatch(getStudentsList());
    }
    catch(error){
        console.error(error);
    }
}

export const getAllClasses = () => async(dispatch, getState) => {
    try{
        const response = await axios.get(`${API_URL}classes`);
        const data = await response.data;
        dispatch(setClasses(data));
    }
    catch(error){
        console.error(error);
    }
}

export default studentSlice.reducer
